// extracted by mini-css-extract-plugin
export default {"avatar":"styles_avatar__yg-T2","letterPlaceholder":"styles_letterPlaceholder__Ci7xZ","avatarContainer":"styles_avatarContainer__yaEnB"};